import { ref, computed, provide, inject, type ComputedRef, type Ref } from 'vue'
import type { ValuesOf } from '@tiptap/core'
import type { ContentType } from '@agenda-selector/constants'

type ApplicationBlockSelectorModal = {
  open: (type: ValuesOf<ContentType>) => void
  close: () => void
  isOpen: Readonly<ComputedRef<boolean>>
  activeElement: Readonly<Ref<ValuesOf<ContentType> | null>>
}

const ApplicationBlockSelectorModalKey = Symbol('applicationBlockSelectorModal')

export function provideApplicationBlockSelectorModal() {
  const activeElement = ref<ValuesOf<ContentType> | null>(null)
  const isOpen = computed(() => !!activeElement.value)

  const close = () => (activeElement.value = null)

  const open = (type: ValuesOf<ContentType>) => {
    activeElement.value = type
  }

  const store = {
    activeElement,
    isOpen,
    open,
    close,
  }

  provide<ApplicationBlockSelectorModal>(ApplicationBlockSelectorModalKey, store)

  return store
}

export function useApplicationBlockSelectorModal() {
  const store = inject<ApplicationBlockSelectorModal>(ApplicationBlockSelectorModalKey)

  if (!store) {
    throw new Error('useApplicationBlockSelectorModal() is called without provider.')
  }

  return store
}
